import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Link from 'fe-design-base/molecules/Link';

import ChatSupportLink from 'features/authentication/SignIn/ChatSupportLink/index';
import { ROUTES } from 'features/signUp/constants';

import { toI18n } from 'util/i18n';

export const SignUpSection = () => (
  <Box w="100%" hcenter column>
    <Box hcenter row gap={8}>
      <Text i18n="authentication.sign_up_text" />
      <Link
        linkTo={ROUTES.CHOOSE_TYPE}
        uxElement="sign up link"
        endIcon="ArrowRight"
      >
        {toI18n('authentication.sign_up_link_alt')}
      </Link>
    </Box>
    <ChatSupportLink />
  </Box>
);

export default SignUpSection;
